import { create } from 'zustand';
import { productsAPI } from '../services/api';

const useProductsStore = create((set) => ({
  products: [],
  featuredProducts: [],
  categories: [],
  currentProduct: null,
  isLoading: false,
  error: null,
  pagination: {
    page: 1,
    pages: 1,
    total: 0,
  },

  fetchProducts: async (params = {}) => {
    set({ isLoading: true, error: null });
    try {
      const response = await productsAPI.getAll(params);
      set({
        products: response.data.products,
        pagination: {
          page: response.data.page,
          pages: response.data.pages,
          total: response.data.total,
        },
        isLoading: false,
      });
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to fetch products', isLoading: false });
    }
  },

  fetchProductById: async (id) => {
    set({ isLoading: true, error: null });
    try {
      const response = await productsAPI.getById(id);
      set({ currentProduct: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to fetch product', isLoading: false });
    }
  },

  fetchFeaturedProducts: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await productsAPI.getFeatured();
      set({ featuredProducts: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to fetch featured products', isLoading: false });
    }
  },

  fetchCategories: async () => {
    try {
      const response = await productsAPI.getCategories();
      set({ categories: response.data });
    } catch (error) {
      console.error('Failed to fetch categories:', error);
    }
  },

  createProduct: async (productData) => {
    set({ isLoading: true, error: null });
    try {
      const response = await productsAPI.create(productData);
      set({ isLoading: false });
      return response.data;
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to create product', isLoading: false });
      throw error;
    }
  },

  updateProduct: async (id, productData) => {
    set({ isLoading: true, error: null });
    try {
      const response = await productsAPI.update(id, productData);
      set({ isLoading: false });
      return response.data;
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to update product', isLoading: false });
      throw error;
    }
  },

  deleteProduct: async (id) => {
    set({ isLoading: true, error: null });
    try {
      await productsAPI.delete(id);
      set({ isLoading: false });
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to delete product', isLoading: false });
      throw error;
    }
  },
}));

export default useProductsStore;
